module.exports = __webpack_public_path__ + "media/assets/images/personas/leonardo-b242e76870494dd51d6a73b13254a5d4.jpg";